export class FileHelper {
  public static async fileToDataURL(file: File): Promise<string | null> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result as string | null)
      reader.onerror = reject
    })
  }
  public static dataURLToBase64(dataUrl: string) {
    return dataUrl.split(',', 2)[1]
  }
  public static async downloadDataURLFile(dataUrl: string, fileName: string) {
    const downloadLink = document.createElement('a')
    downloadLink.href = dataUrl
    downloadLink.download = fileName
    downloadLink.click()
  }

  public static async downloaBase64File(base64String: string, fileName: string, contentType: string) {
    const dataUrl = `data:${contentType};base64,${base64String}`
    return this.downloadDataURLFile(dataUrl, fileName)
  }

  public static checkFileType(file: string) {
    return file.includes('application/pdf') ? 'pdf' : file.includes('image') ? 'image' : 'invalid'
  }
  public static isFileType(file: string, targetType: 'image' | 'pdf') {
    return this.checkFileType(file) === targetType
  }
}
